import axios from 'axios'
import iView from 'iview'
import router from '../../../router'
import { BASE_URL, TOKEN } from './const.js'

  var axiosJava = axios.create({
     // baseURL: `http://cdl.natapp1.cc/javaapi`,
     // baseURL: `http://localhost:8088/javaapi`,
     baseURL: `https://dms.zimmerbiomet.cn/javaapi`,
    //测试runn
    // baseURL: `http://139.224.101.166:8898/api`,
    //正式
    // baseURL: `http://139.224.101.166:8899/api`,
    timeout: 60000000, // 20s
    headers: { 'Content-Type': 'application/json'}
})

axiosJava.interceptors.request.use(
    config => {
        iView.LoadingBar.start()
        //iView.Spin.show();
        if (sessionStorage.getItem("dms-app-java-token")) {
            config.headers.Authorization = sessionStorage.getItem("dms-app-java-token")
        }
        if (config.method == 'get') {
            config.params = {
                ...config.params,
                _t: Date.parse(new Date()) / 1000
            }
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

axiosJava.interceptors.response.use(
    response => {
        iView.LoadingBar.finish()
        //iView.Spin.hide();
        if (process.env.WEB_ENV) {
            return response.data.data;
        }
        else {
            return response.data;
        }
    },
    error => {
        iView.LoadingBar.error()
        if (error.response) {
           debugger
            switch (error.response.status) {
                case 401:
                    // iView.Message.error("登录超时");
                    // localStorage.clear();
                    router.replace({ name: 'login' })
                    break
                case 403:
                    //iView.Message.error("系统异常:403");
                    // localStorage.clear();
                    router.push({ name: 'page403' })
                    break
                case 404:

                    iView.Message.error("系统异常:404");
                    // localStorage.clear();
                    // router.replace({ name: 'page401' })
                    break
                case 500:
                    if(error.response.data.message.indexOf('JWT expired') > -1) {
                        iView.Message.error("系统异常:JWT expired");
                        router.replace({ name: 'login' })
                    } else {
                        if (process.env.WEB_ENV) {
                            iView.Message.error(error.response.data.data.message);

                        } else {
                            if (error.response.data.message !== null) {
                                iView.Message.error(error.response.data.message);
                            }
                            else {
                                iView.Spin.hide();
                                iView.Message.error("系统异常");
                            }
                        }
                    }
                    break
                case 504:
                    iView.Message.error("系统异常:504");
                    return error.response;
                    break
            }
        }
        return Promise.reject(error)
    }
)

export default axiosJava



// WEBPACK FOOTER //
// ./src/api/services/common/java.js